export const SHOW_ERROR_MODAL = 'SHOW_ERROR_MODAL';
export const HIDE_ERROR_MODAL = 'HIDE_ERROR_MODAL';

export const SHOW_BIND_SAAS_POP = 'SHOW_BIND_SAAS_POP';
export const HIDE_BIND_SAAS_POP = 'HIDE_BIND_SAAS_POP';

export const SHOW_ADD_GOODS_POP = 'SHOW_ADD_GOODS_POP';
export const HIDE_ADD_GOODS_POP = 'HIDE_ADD_GOODS_POP';

export const SHOW_CHOOSE_MEDIA_POP = 'SHOW_CHOOSE_MEDIA_POP';
export const HIDE_CHOOSE_MEDIA_POP = 'HIDE_CHOOSE_MEDIA_POP';

export const SHOW_WITHDRAW_POP = 'SHOW_WITHDRAW_POP';
export const HIDE_WITHDRAW_POP = 'HIDE_WITHDRAW_POP';

export const SET_WS_MEDIA_USER_LIST = 'SET_WS_MEDIA_USER_LIST';
export const SET_WS_CURRENT_MEDIA_USER = 'SET_WS_CURRENT_MEDIA_USER';

export const SET_EXPORT_STATUS = 'SET_EXPORT_STATUS';
export const SET_EXPORT_SUMMARY_STATUS = 'SET_EXPORT_SUMMARY_STATUS';
export const SET_EXPORT_ORDER_STATUS = 'SET_EXPORT_ORDER_STATUS';

export const SHOW_WITHDRAW_GUIDE_POP = 'SHOW_WITHDRAW_GUIDE_POP';
export const HIDE_WITHDRAW_GUIDE_POP = 'HIDE_WITHDRAW_GUIDE_POP';

export const SHOW_CHANGE_BIND_POP = 'SHOW_CHANGE_BIND_POP';
export const HIDE_CHANGE_BIND_POP = 'HIDE_CHANGE_BIND_POP';

export const SHOW_ADD_ACCOUNT_POP = 'SHOW_ADD_ACCOUNT_POP';
export const HIDE_ADD_ACCOUNT_POP = 'HIDE_ADD_ACCOUNT_POP';

export const SHOW_INVITE_QRCODE_POP = 'SHOW_INVITE_QRCODE_POP';
export const HIDE_INVITE_QRCODE_POP = 'HIDE_INVITE_QRCODE_POP';

export const SHOW_BIND_MEDIA_POP = 'SHOW_BIND_MEDIA_POP';
export const HIDE_BIND_MEDIA_POP = 'HIDE_BIND_MEDIA_POP';

export const SHOW_BIND_PHONE_POP = 'SHOW_BIND_PHONE_POP';
export const HIDE_BIND_PHONE_POP = 'HIDE_BIND_PHONE_POP';

export const SHOW_PDD_TOKEN_EXPIRE_POP = 'SHOW_PDD_TOKEN_EXPIRE_POP';
export const HIDE_PDD_TOKEN_EXPIRE_POP = 'HIDE_PDD_TOKEN_EXPIRE_POP';

export const SET_PDD_TOKEN_EXPIRE = 'SET_PDD_TOKEN_EXPIRE';

export const SET_CHROME_WARNING = 'SET_CHROME_WARNING';
